export default "__VITE_ASSET__Cz_Xvnt2__";